
import { supabase } from '@/integrations/supabase/client';

export const fetchPlaylistById = async (id: string) => {
  if (!id) {
    console.warn("fetchPlaylistById called with empty ID");
    return null;
  }
  
  try {
    // Log the attempt to fetch the playlist
    console.log(`Attempting to fetch playlist with ID: ${id}`);
    
    const { data, error } = await supabase
      .from('playlists')
      .select('*, channels(id, name, logo)')
      .eq('id', id)
      .maybeSingle();
    
    if (error) {
      console.error(`Error fetching playlist ${id}:`, error);
      return null;
    }
    
    if (data) {
      console.log(`Successfully fetched playlist:`, data);
      return data;
    } else {
      console.log(`No playlist found with ID: ${id}`);
      return null;
    }
  } catch (error) {
    console.error('Unexpected error fetching playlist:', error);
    return null;
  }
};

// Making this function compatible with React Query
export const fetchPlaylistsByChannelId = async (channelId: string) => {
  console.log(`Fetching playlists for channel: ${channelId}`);
  try {
    const { data, error } = await supabase
      .from('playlists')
      .select('*')
      .eq('channel_id', channelId);
    
    if (error) {
      console.error(`Error fetching playlists for channel ${channelId}:`, error);
      return [];
    }
    
    return data || [];
  } catch (error) {
    console.error('Unexpected error fetching playlists:', error);
    return [];
  }
};

// Create a wrapper for React Query compatibility
export const getPlaylistsByChannelId = (channelId: string) => {
  return async () => {
    return await fetchPlaylistsByChannelId(channelId);
  };
};
